import { useMemo } from 'react';

import { getTabs } from 'src/app/pages/petition/shared/tabs';
import type { TabConfig, TabIsHiddenContext } from 'src/app/pages/petition/shared/tabs';

export function useTabs(context: TabIsHiddenContext): readonly TabConfig[] {
	return useMemo(() => getTabs().filter(({ isHidden }) => !isHidden || !isHidden(context)), [context]);
}
